import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddAddressFormComponent } from './add-address-form/add-address-form.component';
import { MatButtonModule, MatCardModule, MatChipsModule, MatDialogModule, MatFormFieldModule, MatIconModule, MatInputModule, MatRadioModule, MatSelectModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomErrorStateMatcher } from '../error-state-matcher/error-state.matcher';
import { FlexLayoutModule } from '@angular/flex-layout';




@NgModule({
  declarations: [
    AddAddressFormComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDialogModule,
    MatChipsModule,
    FlexLayoutModule
    
  ],
  exports: [
    AddAddressFormComponent,
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatDialogModule,
    MatChipsModule,
    FlexLayoutModule
    
  ]
})
export class ReuseModule { }
